import * as yup from 'yup'
import { checkIfOwnCard } from '../../lib/Validations'
import { getCustomerFromMemory } from '../../lib/sharedSessionMemory'

const jwt = getCustomerFromMemory()
const myCards = jwt?.data?.card

const FormSchema = yup.object().shape({
    card_number: yup.string().required("Número do cartão inválido"),
    card_expiration_date: yup.string().test("isValidExpiration", "O vencimento é inválido.", function(value) {
        return (value && value.match(/^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/)) ? true : false
    }).required("Data de expiração inválida"),
    card_cvv: yup.string().test("isValidCVV", "Número do CVV inválido.", function(value) {
        return (value && /^[0-9]{3,4}$/.test(value));  
    }).required("Número do CVV inválido"),
    card_holder_name: yup.string().required("Nome do titular inválido"),
    card_document: yup.string().required("CPF do titular inválido"),
});

export default FormSchema

